import React from 'react';
import Products from './Products';

const ProductsPage = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <Products />
    </div>
  );
};

export default ProductsPage; 